class RecentlyViewed {
  constructor() {
    this.sections = document.querySelectorAll('[data-use-recently-viewed="true"]');
    this.cookieName = 'shopify_recently_viewed';
    this.maxProducts = 12;

    if (this.sections.length > 0) {
      this.init();
    }
  }

  init() {
    this.sections.forEach(section => {
      const placeholder = section.querySelector('.recently-viewed-placeholder');
      // We only proceed if this specific section is configured for recently viewed products
      // and has a placeholder element.
      if (placeholder) {
        this.handleSection(section, placeholder);
      } else {
        // If the section is marked but has no placeholder, we still need to check if it should be hidden.
        // This might happen if a developer omitted the placeholder intentionally.
        // In this case, we'll hide the section if there are no products to show.
        const productHandles = this.getRecentlyViewedProducts();
        if (productHandles.length === 0) {
          this.hideSection(section);
        }
      }
    });
  }

  handleSection(section, placeholder) {
    const productHandles = this.getRecentlyViewedProducts();

    // If no product handles are found for this specific section
    if (productHandles.length === 0) {
      // Hide the entire section that is meant for recently viewed products
      this.hideSection(section);
      return;
    }

    // If there are handles, proceed to fetch and display them
    this.fetchProducts(productHandles, placeholder, section); // Pass section here
  }

  getRecentlyViewedProducts() {
    const cookieValue = this.getCookie(this.cookieName);
    if (!cookieValue) return [];

    let productHandles = cookieValue.split(' ');

    const currentPath = window.location.pathname;
    const currentHandle = currentPath.match(/\/products\/([^\/]+)/);

    if (currentHandle && currentHandle[1]) {
      productHandles = productHandles.filter(handle => handle !== currentHandle[1]);
    }

    return productHandles.slice(0, this.maxProducts);
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  removeHandleFromCookie(handle) {
    const currentHandles = this.getRecentlyViewedProducts();
    const updatedHandles = currentHandles.filter(h => h !== handle);
    
    // Set cookie to expire in 30 days
    const date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    
    document.cookie = `${this.cookieName}=${updatedHandles.join(' ')}${expires}; path=/`;
  }

  fetchProducts(productHandles, placeholder, section) { // Accept section here
    const pathname = window.location.pathname;
    const localeMatch = pathname.match(/^\/([a-z]{2}(?:-[A-Z]{2})?)(?:\/|$)/);
    const currentLocalePrefix = localeMatch && localeMatch[1] ? `/${localeMatch[1]}` : '';

    Promise.all(
      productHandles.map(handle => {
        const fetchUrl = `${currentLocalePrefix}/products/${handle}?view=recently_viewed_item`;
        return fetch(fetchUrl)
          .then(response => {
             if (!response.ok) {
              console.info(`Fetch failed for ${fetchUrl}: ${response.status} ${response.statusText}`);
              if (response.status === 404) {
                this.removeHandleFromCookie(handle);
              }
              return ''; // Return empty string on failure to allow Promise.all to complete
             }
             return response.text();
          })
          .catch(error => {
             console.error(`Fetch error for ${fetchUrl}:`, error);
             return ''; // Return empty string on error
          });
      })
    )
    .then(responses => {
      const validResponses = responses.filter(response => response.trim() !== '');

      if (validResponses.length === 0) {
        // If no products were successfully fetched, hide the section
        this.hideSection(section);
        return;
      }

      let productsHTML = '';
      validResponses.forEach(html => {
        productsHTML += `<div class="product-slide">${html}</div>`;
      });

      placeholder.innerHTML = productsHTML;

      const event = new CustomEvent('recentlyViewedLoaded', {
        detail: {
          container: placeholder
        }
      });
      document.dispatchEvent(event);
    });
  }

  // This method correctly hides the section element itself
  hideSection(sectionElement) {
    if (sectionElement && sectionElement.style) {
      sectionElement.style.display = 'none';
    }
  }
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', () => {
  new RecentlyViewed();
});